export const defaultSortMethod = (a: any, b: any) => (a < b ? -1 : a > b ? 1 : 0)
